// 7 Max
/*
IBM Plex Sans
REM
Inclusive Sans
Space Grotesk
General Sans
Onest
Overpass
Kalam
Nanum Pen Script
*/

export const fonts: {
  name: string;
  importSnippet: string;
}[] = [
  {
    name: "IBM Plex Sans",
    importSnippet:
      "@import url('https://fonts.googleapis.com/css2?family=IBM+Plex+Sans:wght@400;500&display=swap');",
  },
  {
    name: "Inclusive Sans",
    importSnippet:
      "@import url('https://fonts.googleapis.com/css2?family=Inclusive+Sans&display=swap');",
  },
  {
    name: "Space Grotesk",
    importSnippet:
      "@import url('https://fonts.googleapis.com/css2?family=Space+Grotesk&display=swap');",
  },
  {
    name: "Onest",
    importSnippet:
      "@import url('https://fonts.googleapis.com/css2?family=Onest:wght@300;400&display=swap');",
  },
  {
    name: "Overpass",
    importSnippet:
      "@import url('https://fonts.googleapis.com/css2?family=Overpass&display=swap');",
  },
  {
    name: "Kalam",
    importSnippet:
      "@import url('https://fonts.googleapis.com/css2?family=Kalam&display=swap');",
  },
  {
    name: "Nanum Pen Script",
    importSnippet:
      "@import url('https://fonts.googleapis.com/css2?family=Nanum+Pen+Script&display=swap');",
  },
  {
    name: "REM",
    importSnippet:
      "@import url('https://fonts.googleapis.com/css2?family=REM:wght@400;500&display=swap');",
  },
];
